import { render } from "./PatientPhysician.vue?vue&type=template&id=a34493fc&ts=true"
import script from "./PatientPhysician.ts?vue&type=script&lang=ts&external"
export * from "./PatientPhysician.ts?vue&type=script&lang=ts&external"

import "./PatientPhysician.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__